<div class="breadcrumb-container">
  <!-- Breadcrumbs -->
  <div class="breadcrumb-container-left-content">
    <a [routerLink]="'/' | localize">
      <i class="bi bi-house breadcrumb-home"></i>
    </a>
    @if (visibleBreadcrumbs.length > 0 && showEllipsis) {
    <div class="breadcrumb-item">
      <i class="bi bi-chevron-right" style="font-size: 0.75rem"></i>
    </div>
    }
    <!-- Ellipsis for breadcrumbs -->
    @if (showEllipsis) {
    <span class="breadcrumb-ellipsis">...</span>
    }
    <!-- Breadcrumbs loop -->
    @for (breadcrumb of visibleBreadcrumbs; track breadcrumb; let i = $index) {
    <div class="breadcrumb-item">
      <i class="bi bi-chevron-right" style="font-size: 0.75rem"></i>
      @if (i < visibleBreadcrumbs.length - 1) {
      <a class="breadcrumb-item-title breadcrumb-item-title-not-active" [routerLink]="breadcrumb.path | localize">
        {{ breadcrumb.name }}
      </a>
      } @else {
      <span class="breadcrumb-item-title breadcrumb-item-title-active">{{ breadcrumb.name }}</span>
      }
    </div>
    }
  </div>
</div>
